import type { FunctionComponent } from 'react';

import styles from './DrawerRoot.module.css';

export const DrawerRoot: FunctionComponent = () => <div id="drawerRoot" className={styles.drawerRoot} />;
